/**
 * Coups de pouce, Attendus 1249 « partager une somme en deux parts selon
 * un certain ratio », 1250 « partager une masse en trois parts selon un
 * certain ratio », 1251 « partager une somme entre deux personnes
 * proportionnellement à leur âge » (3e, Proportionnalité ; un fichier
 * gen_1249 à trois jeux de clés). Seconde passe 3e (2026-09-13). UNE page
 * STATIQUE par attendu, le même dessin : la barre en parts égales du cycle
 * 3 (fiches 1046 / 1049), l'image que l'élève a déjà.
 *   1249 « 2 : 3, c'est 5 parts » : 100 € en 2 : 3 ; 2 + 3 = 5 parts ;
 *     100 ÷ 5 = 20 € la part ; 2 parts = 40 €, 3 parts = 60 €. Vérification
 *     40 + 60 = 100.
 *   1250 « 1 : 2 : 3, c'est 6 parts » : 600 g en 1 : 2 : 3 ; 6 parts ;
 *     600 ÷ 6 = 100 g ; 100 g, 200 g, 300 g.
 *   1251 « Les âges donnent le ratio » : 250 € entre 20 ans et 30 ans ;
 *     20 : 30, c'est 2 : 3, 5 parts ; 250 ÷ 5 = 50 € la part ; 100 € et
 *     150 € (l'exemple du programme, l. 1388 ; âges hors plage 8..16).
 *
 * SACRIFIÉS (gen_1249, gen1249-1251.self.test.js) : (100 € ; 2 : 3) et
 * (600 g ; 1 : 2 : 3) ; 1251 : 250 € et 20 / 30 ans hors plage.
 */
import { svg } from './1054';

const ORANGE = '#EA580C';
const BLEU = '#2563EB';
const ENCRE = '#1E293B';
const GRIS = '#64748B';
const BLEU_CLAIR = '#DBEAFE';
const ORANGE_CLAIR = '#FED7AA';
const VERT = '#15803D';
const VERT_CLAIR = '#DCFCE7';

const ligne = (y, contenu, taille = 12, couleur = ENCRE) => `<text x="200" y="${y}" font-size="${taille}" text-anchor="middle" fill="${couleur}">${contenu}</text>`;
const gras = (t, couleur = ENCRE) => `<tspan font-weight="bold" fill="${couleur}">${t}</tspan>`;

/** La barre de `groupes` (nombre de parts, couleur, fond, étiquette), parts égales de largeur `w`, accolade du total dessous. */
const barre = (y, groupes, w, total, valeurPart) => {
    const n = groupes.reduce((s, g) => s + g.n, 0);
    const x0 = 200 - (n * w) / 2;
    let x = x0; const out = [];
    groupes.forEach((g) => {
        for (let k = 0; k < g.n; k++) {
            out.push(`<rect x="${x}" y="${y}" width="${w}" height="30" fill="${g.fond}" stroke="${g.couleur}" stroke-width="1.4"/>`);
            out.push(`<text x="${x + w / 2}" y="${y + 20}" font-size="12" font-weight="bold" text-anchor="middle" fill="${g.couleur}">${valeurPart}</text>`);
            x += w;
        }
        out.push(`<text x="${x - (g.n * w) / 2}" y="${y - 8}" font-size="12" font-weight="bold" text-anchor="middle" fill="${g.couleur}">${g.etiquette}</text>`);
    });
    out.push(`<path d="M ${x0} ${y + 36} L ${x0} ${y + 44} L ${x0 + n * w} ${y + 44} L ${x0 + n * w} ${y + 36}" fill="none" stroke="${GRIS}" stroke-width="1.2"/>`);
    out.push(`<text x="200" y="${y + 58}" font-size="12" text-anchor="middle" fill="${GRIS}">${total}</text>`);
    return out.join('\n  ');
};

// ─── 1249 : 100 € en 2 : 3 ─────────────────────────────────────────────────

const SVG_DEUX = svg(
    'Une barre de 100 euros coupée en 5 parts égales : 2 parts bleues et 3 parts orange, chaque part vaut 20 euros. 2 plus 3 égale 5 parts, 100 divisé par 5 égale 20 euros la part. 2 parts font 40 euros, 3 parts font 60 euros. Vérification : 40 plus 60 égale 100.',
    `${barre(56, [{ n: 2, couleur: BLEU, fond: BLEU_CLAIR, etiquette: '2 parts : 40 €' }, { n: 3, couleur: ORANGE, fond: ORANGE_CLAIR, etiquette: '3 parts : 60 €' }], 56, '100 € en tout', '20 €')}
  ${ligne(150, `2 : 3, c’est ${gras('2 + 3 = 5 parts')} égales.`, 13)}
  ${ligne(174, `Une part : 100 ÷ 5 = ${gras('20 €')}. Puis ${gras('2 × 20 = 40 €', BLEU)} et ${gras('3 × 20 = 60 €', ORANGE)}.`, 13)}
  ${ligne(198, 'Je vérifie : 40 + 60 = 100.', 12, GRIS)}`,
    214,
);

// ─── 1250 : 600 g en 1 : 2 : 3 ─────────────────────────────────────────────

const SVG_TROIS = svg(
    'Une barre de 600 grammes coupée en 6 parts égales : 1 part bleue, 2 parts orange, 3 parts vertes, chaque part vaut 100 grammes. 1 plus 2 plus 3 égale 6 parts, 600 divisé par 6 égale 100 grammes la part. Les trois parts : 100, 200 et 300 grammes. Vérification : 100 plus 200 plus 300 égale 600.',
    `${barre(56, [{ n: 1, couleur: BLEU, fond: BLEU_CLAIR, etiquette: '100 g' }, { n: 2, couleur: ORANGE, fond: ORANGE_CLAIR, etiquette: '200 g' }, { n: 3, couleur: VERT, fond: VERT_CLAIR, etiquette: '300 g' }], 50, '600 g en tout', '100')}
  ${ligne(150, `1 : 2 : 3, c’est ${gras('1 + 2 + 3 = 6 parts')} égales.`, 13)}
  ${ligne(174, `Une part : 600 ÷ 6 = ${gras('100 g')}. Puis 1, 2 et 3 parts : 100 g, 200 g, 300 g.`, 13)}
  ${ligne(198, 'Je vérifie : 100 + 200 + 300 = 600.', 12, GRIS)}`,
    214,
);

// ─── 1251 : 250 € entre 20 ans et 30 ans ───────────────────────────────────

const SVG_AGES = svg(
    '250 euros à partager entre deux personnes de 20 ans et 30 ans, proportionnellement à leur âge. 20 et 30, c’est le ratio 2 : 3 : une barre de 5 parts égales, chaque part vaut 50 euros. La personne de 20 ans reçoit 2 parts, 100 euros ; celle de 30 ans reçoit 3 parts, 150 euros. Vérification : 100 plus 150 égale 250.',
    `${barre(56, [{ n: 2, couleur: BLEU, fond: BLEU_CLAIR, etiquette: '20 ans : 100 €' }, { n: 3, couleur: ORANGE, fond: ORANGE_CLAIR, etiquette: '30 ans : 150 €' }], 56, '250 € en tout', '50 €')}
  ${ligne(150, `Les âges donnent le ratio : 20 : 30, c’est ${gras('2 : 3')}, donc ${gras('5 parts')}.`, 13)}
  ${ligne(174, `Une part : 250 ÷ 5 = ${gras('50 €')}. Puis ${gras('2 × 50 = 100 €', BLEU)} et ${gras('3 × 50 = 150 €', ORANGE)}.`, 13)}
  ${ligne(198, 'Je vérifie : 100 + 150 = 250. Le plus âgé reçoit le plus.', 12, GRIS)}`,
    214,
);

const AIDE_DEUX = { pages: [{ titre: '2 : 3, c’est 5 parts', svg: SVG_DEUX }] };
const AIDE_TROIS = { pages: [{ titre: '1 : 2 : 3, c’est 6 parts', svg: SVG_TROIS }] };
const AIDE_AGES = { pages: [{ titre: 'Les âges donnent le ratio', svg: SVG_AGES }] };

const CP_1249 = { deux_flash_texte_trou_saisie: AIDE_DEUX, deux_qcm_unique: AIDE_DEUX, deux_tableau_vf: AIDE_DEUX };
export const CP_1250 = { trois_flash_texte_trou_saisie: AIDE_TROIS, trois_qcm_unique: AIDE_TROIS, trois_tableau_vf: AIDE_TROIS };
export const CP_1251 = { age_flash_texte_trou_saisie: AIDE_AGES, age_qcm_unique: AIDE_AGES, age_tableau_vf: AIDE_AGES };

export default CP_1249;
